import { render, staticRenderFns } from "./fracs.vue?vue&type=template&id=4417bb2c&scoped=true"
import script from "./fracs.vue?vue&type=script&lang=js"
export * from "./fracs.vue?vue&type=script&lang=js"
import style0 from "./fracs.vue?vue&type=style&index=0&id=4417bb2c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4417bb2c",
  null
  
)

export default component.exports